module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row no-gutters">\n  <div class="col-xs-12 col-md-6 fmcy-cart-payment-left-column"></div>\n  <div class="col-xs-12 col-md-6 fmcy-cart-payment-right-column">\n    <div class="fmcy-cart-payment-title">Order Payment '+
((__t=(orderCode))==null?'':__t)+
'</div>\n    <div class="fmcy-cart-payment-error-message-region"></div>\n     ';
 if (paymentMethod == 'credit') { 
__p+='\n    <div class="fmcy-cart-payment-credit-cards">\n      <span class="mastercard-xs"></span><span class="visa-xs"></span><span class="amex-xs"></span>  &nbsp;&nbsp;&nbsp;&nbsp;<span class="discover-xs"></span>\n    </div>\n    ';
 } 
__p+='\n    ';
 if (paymentMethod == 'interac') { 
__p+='\n   <div class="fmcy-cart-payment-interac">\n     <div class="interac-icon"></div>\n   </div>\n   ';
 } 
__p+='\n    <div class="fmcy-cart-payment-total">\n      <div class="fmcy-cart-payment-total-cost-label fmcy-cart-payment-field-label">\n        Payment amount\n      </div>\n      <div class="fmcy-cart-payment-total-cost">'+
((__t=(cartTotalCost))==null?'':__t)+
'</div>\n    </div>\n    <div class="fmcy-cart-payment-pay-form-region">\n      ';
 if (paymentMethod == 'interac') { 
__p+='\n     <div class="fmcy-cart-payment-interac-information-text">\n       You will be prompted to log in to your issuing bank and approve a payment to Original Farm. Please note that for INTERAC Online transactions, the funds will be withdrawn from your bank account immediately after you place your order. Any adjustments or order cancellations will be refunded directly to your account at the time of processing.\n     </div>\n     ';
 } 
__p+='\n    </div>\n  </div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-payment/cart-payment.html
 ** module id = 882
 ** module chunks = 1 9 84
 **/